export const combinePurchaseWithSubs = (purchase, lineItems, subs) => {
  const lines = lineItems.map((line) => {
    let subscription;
    if (line.subscription) {
      subscription = subs.find(
        (sub) => sub.id === line.subscription && sub.sprint_status,
      );
    } else if (line.att_subscription) {
      subscription = subs.find(
        (sub) => sub.id === line.att_subscription && sub.att_status,
      );
    } else if (line.tracfone_subscription) {
      subscription = subs.find(
        (sub) => sub.id === line.tracfone_subscription && sub.tracfone_status,
      );
    } else if (line.simo_subscription) {
      subscription = subs.find(
        (sub) => sub.id === line.simo_subscription && sub.simo_status,
      );
    }

    return {
      ...line,
      subscription: subscription ? subscription : null,
    };
  });

  let combinedObject = {
    ...purchase,
    ...purchase.cost,
    line_items: lines,
  };

  if (purchase.shipping) {
    combinedObject.shipping_service = purchase.shipping.shipping_service;
    combinedObject.shipping_carrier = purchase.shipping.shipping_carrier;
  }

  return combinedObject;
};

export const injectPlansIntoLineItems = (purchase, plans) => {
  const lines = purchase.line_items.map((line) => {
    let planObj;
    if (line.sprint_plan) {
      planObj = plans.find(
        (plan) => plan.carrier === 'sprint' && plan.id === line.sprint_plan,
      );
    } else if (line.att_plan) {
      planObj = plans.find(
        (plan) => plan.carrier === 'att' && plan.id === line.att_plan,
      );
    } else if (line.tracfone_plan) {
      planObj = plans.find(
        (plan) => plan.carrier === 'tracfone' && plan.id === line.tracfone_plan,
      );
    }

    if (!planObj) return { ...line };

    let { plan, ...lineItem } = line;
    return {
      ...lineItem,
      [`${planObj.carrier}_plan`]: planObj,
    };
  });

  return {
    ...purchase,
    line_items: lines,
  };
};
